// Section divider shape library. Each entry is an SVG fragment
// stretched across the full block width (preserveAspectRatio="none").
// Most have a single path; multi-path shapes (e.g. peaks) layer a
// few paths with different opacities so a single user-picked colour
// reads as foreground + atmosphere washes behind it.

export const DIVIDER_SHAPES = {
    none: null,

    slant_right: {
        label: 'Slant — rising right',
        viewBox: '0 0 1440 80',
        height: 80,
        paths: [{ d: 'M0,80 L1440,0 L1440,80 Z' }],
    },
    slant_left: {
        label: 'Slant — rising left',
        viewBox: '0 0 1440 80',
        height: 80,
        paths: [{ d: 'M0,0 L1440,80 L0,80 Z' }],
    },
    tilt: {
        label: 'Tilt — gentle',
        viewBox: '0 0 1440 80',
        height: 60,
        paths: [{ d: 'M0,80 L1440,40 L1440,80 Z' }],
    },

    peaks: {
        label: 'Mountain peaks',
        viewBox: '0 0 1440 125',
        height: 120,
        paths: [
            { d: 'M0,125 L480,20 L960,125 Z', opacity: 0.35 },
            { d: 'M480,125 L960,0 L1440,125 Z', opacity: 0.6 },
            { d: 'M0,125 L0,90 L720,40 L1440,90 L1440,125 Z' },
        ],
    },
    peaks_right: {
        label: 'Mountain range — rising right',
        viewBox: '0 0 1440 140',
        height: 130,
        paths: [
            { d: 'M0,140 L520,80 L900,30 L1440,140 Z', opacity: 0.3 },
            { d: 'M260,140 L780,55 L1180,10 L1440,140 Z', opacity: 0.55 },
            { d: 'M0,140 L0,115 L420,100 L820,75 L1140,45 L1440,15 L1440,140 Z' },
        ],
    },
    peaks_left: {
        label: 'Mountain range — rising left',
        viewBox: '0 0 1440 140',
        height: 130,
        paths: [
            { d: 'M0,140 L540,30 L920,80 L1440,140 Z', opacity: 0.3 },
            { d: 'M0,140 L260,10 L660,55 L1180,140 Z', opacity: 0.55 },
            { d: 'M0,140 L0,15 L300,45 L620,75 L1020,100 L1440,115 L1440,140 Z' },
        ],
    },
    mountain_range: {
        label: 'Mountain range — jagged',
        viewBox: '0 0 1440 150',
        height: 140,
        paths: [
            { d: 'M0,150 L180,80 L360,110 L580,40 L780,90 L1000,30 L1220,100 L1440,60 L1440,150 Z', opacity: 0.3 },
            { d: 'M0,150 L120,110 L300,90 L520,60 L740,100 L960,55 L1180,95 L1380,75 L1440,90 L1440,150 Z', opacity: 0.55 },
            { d: 'M0,150 L0,130 L160,115 L340,125 L540,100 L740,120 L940,95 L1160,125 L1340,105 L1440,120 L1440,150 Z' },
        ],
    },
    triangle_down: {
        label: 'Triangle — pointing down',
        viewBox: '0 0 1440 80',
        height: 80,
        paths: [{ d: 'M0,0 L720,80 L1440,0 L1440,80 L0,80 Z' }],
    },
    triangle_up: {
        label: 'Triangle — pointing up',
        viewBox: '0 0 1440 80',
        height: 80,
        paths: [{ d: 'M0,80 L720,0 L1440,80 Z' }],
    },
    zigzag: {
        label: 'Zigzag',
        viewBox: '0 0 1440 80',
        height: 50,
        paths: [{ d: 'M0,80 L240,40 L480,80 L720,40 L960,80 L1200,40 L1440,80 Z' }],
    },

    wave: {
        label: 'Wave',
        viewBox: '0 0 1440 80',
        height: 70,
        paths: [{ d: 'M0,40 C360,90 1080,-10 1440,40 L1440,80 L0,80 Z' }],
    },
    curve_up: {
        label: 'Curve — concave',
        viewBox: '0 0 1440 80',
        height: 70,
        paths: [{ d: 'M0,80 Q720,0 1440,80 Z' }],
    },
    curve_down: {
        label: 'Curve — convex',
        viewBox: '0 0 1440 80',
        height: 70,
        paths: [{ d: 'M0,0 Q720,80 1440,0 L1440,80 L0,80 Z' }],
    },
    arrow: {
        label: 'Arrow notch',
        viewBox: '0 0 1440 80',
        height: 60,
        paths: [{ d: 'M0,0 L660,0 L720,60 L780,0 L1440,0 L1440,80 L0,80 Z' }],
    },
};

// Order in the editor picker.
export const DIVIDER_ORDER = [
    'none',
    'slant_right', 'slant_left', 'tilt',
    'peaks', 'peaks_right', 'peaks_left', 'mountain_range',
    'triangle_down', 'triangle_up', 'zigzag',
    'wave', 'curve_up', 'curve_down', 'arrow',
];
